import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaPlus, FaMinus } from 'react-icons/fa';

function Accordian({ postDataFaq }) {
  const [activeKey, setActiveKey] = useState(null);

  const toggleAccordion = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  const generateFaqSchema = () => {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": postDataFaq.map(faq => ({
        "@type": "Question",
        "name": faq.faq_que,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.faq_ans
        }
      }))
    };
  };

  useEffect(() => {
    if (postDataFaq && postDataFaq.length > 0) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(generateFaqSchema());
      document.head.appendChild(script);

      return () => {
        document.head.removeChild(script);
      };
    }
  }, [postDataFaq]);

  return (
    <div>
      {postDataFaq && postDataFaq.length > 0 ? (
        <>
          <h3 style={{ textAlign: 'center', fontWeight: '700' }}>Frequently Asked Questions (FAQ's)</h3>
          {postDataFaq.map((faq, index) => (
            <div
              key={faq.id}
              className="p-3 border mb-2"
              style={{ cursor: 'pointer' }}
              onClick={() => toggleAccordion(index)}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div><strong>{faq.faq_que}</strong></div>
                <div>{activeKey === index ? <FaMinus /> : <FaPlus />}</div>
              </div>
              {activeKey === index && (
                <div className="mt-2">
                  {faq.faq_ans}
                </div>
              )}
            </div>
          ))}
        </>
      ) : (
        <span></span>
      )}
    </div>
  );
}

export default Accordian;
